import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileSummary.scss'
import * as layoutStyles from '../../../common/Layout/_Layout.scss'
import { Row, Col } from 'react-bootstrap'
import Rating from '../../../common/Rating'
import Spinner from '../../../common/Spinners/Spinner'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../common/Buttons/SecondaryActionButton'
import AdviserProfilePictures from '../../../common/AdviserProfiles/AdviserProfilePictures'
import AdviserProfileFinancialServicesOffered from '../../../common/AdviserProfiles/AdviserProfileFinancialServicesOffered'
import AdviserProfileBlurb from '../../../common/AdviserProfiles/AdviserProfileBlurb'
import DistanceToAdviser from '../../../common/DistanceToAdviser'
import IsIndependent from '../../../common/AdviserProfiles/IsIndependent'

class AdviserProfileSummary extends React.Component {
  static propTypes = {
    adviser: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    contactAdviser: PropTypes.func.isRequired,
    viewProfile: PropTypes.func.isRequired,
    investorLocation: PropTypes.string
  };

  render () {
    if (this.props.loading) {
      return <Spinner />
    }

    const profile = this.props.adviser

    return (
      <div>
        <Row className={layoutStyles['content-well']}>
          <Col sm={4} md={4} lg={3}>
            <AdviserProfilePictures
              profilePicture={profile.profilePic}
              companyLogo={profile.companyLogo}
            />
            <Rating
              className={styles['ag-red']}
              average={profile?.rating?.average ?? 0}
              totalReviews={profile?.rating?.totalReviews ?? 0}
            />
            <IsIndependent
              isIndependent={profile.isIndependent}
              className={styles['is-independnent-margin']}
              conflictDeclarations={profile.conflictDeclarations}
            />
            <PrimaryActionButton
              className={
                styles['full-width'] + ' ' + layoutStyles['margin-top-and-bottom-25']
              }
              buttonText={'Contact adviser'}
              onClick={() => this.props.contactAdviser(profile)}
            />
            <SecondaryActionButton
              className={styles['full-width'] + ' ' + styles['view-profile-match']}
              buttonText={'View full profile'}
              onClick={() => this.props.viewProfile(profile)}
            />
          </Col>
          <Col sm={5} md={5} lg={6}>
            <AdviserProfileBlurb profile={profile} more />
          </Col>
          <Col sm={3} md={3} lg={3}>
            <DistanceToAdviser
              fromLocation={this.props.investorLocation}
              toLocation={`${profile.streetAddress}, ${profile.suburb}, ${profile.city}, South Africa`}
              distanceToAdviser={profile.distanceToAdviser}
            />
            <Row>
              <Col sm={12} md={12} lg={12}>
                <AdviserProfileFinancialServicesOffered
                  financialServices={profile.financialServicesOffered}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (AdviserProfileSummary)
